import type { ComponentProps } from 'react';

type RtlCrimeLogoProps = ComponentProps<'svg'> & {
  readonly colors?: [string, string, string, string];
};

const RtlCrimeLogo = ({ colors, ...props }: RtlCrimeLogoProps) => {
  return (
    <svg viewBox="0 0 72 24" focusable="false" role="img" {...props}>
      <title>RTL Crime</title>
      <path fill={colors?.[0] ?? '#edc00c'} d="M72 0H49.498v12.602H72z" />
      <path fill={colors?.[0] === '#ffffff' ? '#000' : '#fff'} d="M56.491 2.896h1.562v5.466h6.954v1.342H56.49z" />
      <path fill={colors?.[1] ?? '#0c39ed'} d="M47.252 0H24.75v12.602h22.502z" />
      <path
        fill={colors?.[1] === '#ffffff' ? '#000' : '#fff'}
        d="M35.218 4.238h-3.954V2.896h9.473v1.342h-3.955v5.467h-1.564z"
      />
      <path fill={colors?.[2] ?? '#009699'} d="M22.502 0H0v12.602h22.502z" />
      <path
        fill={colors?.[2] === '#ffffff' ? '#000' : '#fff'}
        d="M6.391 2.896h5.996c1.826 0 2.842.818 2.842 2.188 0 1.176-.762 1.965-2.06 2.15l2.94 2.471h-2.256l-2.764-2.384H7.955v2.383H6.393V2.896zm5.792 3.151c.967 0 1.435-.311 1.435-.944 0-.632-.468-.934-1.435-.934H7.955v1.876h4.228z"
      />
      <path
        fill={colors?.[3] ?? '#050508'}
        d="M21.802 23.57a2.9 2.9 0 0 1-1.19-1.22q-.415-.792-.415-1.852 0-1.069.414-1.86a2.93 2.93 0 0 1 1.19-1.226q.777-.432 1.831-.433.889 0 1.581.316.694.316 1.099.89t.473 1.322h-1.259a1.47 1.47 0 0 0-.58-1.036q-.504-.384-1.314-.384-1.035 0-1.6.642-.567.643-.567 1.77t.567 1.759q.567.631 1.6.632.79 0 1.278-.354.489-.356.624-.996h1.25a2.65 2.65 0 0 1-.504 1.288q-.414.56-1.094.865-.678.306-1.557.307-1.05-.004-1.827-.43M33.88 23.793v.096h-1.405l-1.69-2.517h-1.552v2.517h-1.25v-6.804h3.3q.692 0 1.204.272.512.273.791.753t.278 1.093q0 .758-.39 1.294-.39.533-1.074.747zm-4.645-5.619v2.11h1.971q.517 0 .805-.287t.288-.792q0-.486-.292-.759-.294-.272-.8-.272zM36.133 23.89h-1.25v-6.803h1.25zM38.976 23.89h-1.25v-6.803h1.464l2.245 3.615h.04l2.294-3.615h1.395v6.804h-1.24v-4.9h-.04l-2.39 3.743h-.097l-2.381-3.772h-.04zM51.805 23.89h-5.047v-6.803h5.047v1.089h-3.797v1.673h3.494v1.078h-3.495v1.876h3.798z"
      />
    </svg>
  );
};

export default RtlCrimeLogo;
